/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ product: NonNullable<unknown> }} Error_App_Not_AllowedInputs */

const en_error_app_not_allowed = /** @type {(inputs: Error_App_Not_AllowedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Your account doesn't give access to ${i?.product}. Ask your contact at Tomorrow for access.`)
};

/**
* | output |
* | --- |
* | "Your account doesn't give access to {product}. Ask your contact at Tomorrow for access." |
*
* @param {Error_App_Not_AllowedInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const error_app_not_allowed = /** @type {((inputs: Error_App_Not_AllowedInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_App_Not_AllowedInputs, { locale?: "en" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_error_app_not_allowed(inputs)
});